import React, { useState, useEffect } from 'react';
import MobileBottomSheet from './MobileBottomSheet';

export default function MobileSizeSheet({ isOpen, onClose, widthCm, heightCm, onDimensionChange, onFixedPriceChange, activeSizes = [], hideSizes = false }) {
  const [localW, setLocalW] = useState(String(widthCm));
  const [localH, setLocalH] = useState(String(heightCm));

  useEffect(() => { setLocalW(String(widthCm)); }, [widthCm]);
  useEffect(() => { setLocalH(String(heightCm)); }, [heightCm]);

  const apply = () => {
    const w = parseFloat(String(localW).replace(',', '.'));
    const h = parseFloat(String(localH).replace(',', '.'));
    if (w > 0 && h > 0) onDimensionChange(w, h);
  };

  return (
    <MobileBottomSheet isOpen={isOpen} onClose={onClose} title="Größe & Format" height="auto">
      {/* Breite x Höhe */}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', marginBottom: '16px' }}>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: '11px', color: 'var(--selenny-text)', opacity: 0.5, display: 'block', marginBottom: '4px' }}>Breite (cm)</label>
          <input
            type="text" inputMode="decimal" value={localW}
            onChange={(e) => setLocalW(e.target.value.replace(/[^0-9.,]/g, ''))}
            onBlur={apply} onKeyDown={(e) => e.key === 'Enter' && apply()}
            onFocus={(e) => setTimeout(() => e.target.select(), 0)}
            style={{
              width: '100%', padding: '12px', border: '1px solid var(--selenny-border)',
              borderRadius: '10px', fontSize: '18px', fontWeight: 600, textAlign: 'center',
              background: 'var(--selenny-surface)', color: 'var(--selenny-text)', outline: 'none',
            }}
          />
        </div>
        <span style={{ fontSize: '18px', color: 'var(--selenny-text)', opacity: 0.3, paddingBottom: '12px' }}>×</span>
        <div style={{ flex: 1 }}>
          <label style={{ fontSize: '11px', color: 'var(--selenny-text)', opacity: 0.5, display: 'block', marginBottom: '4px' }}>Höhe (cm)</label>
          <input
            type="text" inputMode="decimal" value={localH}
            onChange={(e) => setLocalH(e.target.value.replace(/[^0-9.,]/g, ''))}
            onBlur={apply} onKeyDown={(e) => e.key === 'Enter' && apply()}
            onFocus={(e) => setTimeout(() => e.target.select(), 0)}
            style={{
              width: '100%', padding: '12px', border: '1px solid var(--selenny-border)',
              borderRadius: '10px', fontSize: '18px', fontWeight: 600, textAlign: 'center',
              background: 'var(--selenny-surface)', color: 'var(--selenny-text)', outline: 'none',
            }}
          />
        </div>
      </div>

      {/* Standardgrößen */}
      {activeSizes.length > 0 && !hideSizes && (
        <div>
          <label style={{ fontSize: '11px', fontWeight: 600, opacity: 0.4, display: 'block', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: 'var(--selenny-text)' }}>Standardgrößen</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '6px' }}>
            {activeSizes.map((s, i) => (
              <button
                key={i}
                onClick={() => { setLocalW(String(s.w)); setLocalH(String(s.h)); onDimensionChange(s.w, s.h); }}
                style={{
                  padding: '10px 8px', borderRadius: '10px', fontSize: '13px', textAlign: 'left',
                  border: widthCm === s.w && heightCm === s.h ? '2px solid var(--selenny-primary)' : '1px solid var(--selenny-border)',
                  background: widthCm === s.w && heightCm === s.h ? 'rgba(59,130,246,0.05)' : 'var(--selenny-surface)',
                  color: 'var(--selenny-text)', cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
                }}
              >
                <span style={{ fontWeight: 500 }}>{s.label}</span>
                {s.fixedPrice > 0 && <span style={{ display: 'block', fontSize: '11px', color: '#22c55e', fontWeight: 600, marginTop: '2px' }}>{s.fixedPrice.toFixed(2)} EUR</span>}
              </button>
            ))}
          </div>
        </div>
      )}
    </MobileBottomSheet>
  );
}
